import {
  Box,
  Button,
  Grid,
  TextField,
  Theme,
  Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import React, { useEffect, useState } from 'react';
import AvatarEditor from './AvatarEditor';

const fields = (provider: string) => ({
  email: {
    title: 'อีเมล',
    readOnly: true,
    type: 'email',
    placeholder: `ล็อกอินด้วย ${provider}`,
    limit: undefined,
  },
  displayName: {
    title: 'ชื่อ',
    readOnly: false,
    type: 'text',
    placeholder: 'ไม่มีชื่อ',
    limit: 20,
  },
});
const useStyles = makeStyles<Theme>((theme) => ({
  textField: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  input: {
    color: 'white',
  },
  saveButton: {
    borderRadius: 16,
    color: 'white',
    paddingLeft: 32,
    paddingRight: 32,
    backgroundColor: '#7683F9',
  },
}));
interface IData {
  email?: string;
  displayName?: string;
}
interface IProps {
  email: string;
  avatarUrl: string;
  displayName: string;
  onSave: (payload: IPayloadSave) => void;
  provider: string;
}
export interface IPayloadSave {
  data: IData;
  photoUrl: string;
}
const ProfileForm: React.FC<IProps> = ({
  email,
  avatarUrl,
  displayName,
  onSave,
  provider,
}) => {
  const { textField, input, saveButton } = useStyles();
  const [data, setData] = useState<IData>({ email, displayName });
  const [photoUrl, setPhotoUrl] = useState<string>(avatarUrl);
  const [savable, setSavable] = useState(false);
  useEffect(() => {
    setSavable(false);
  }, [avatarUrl, displayName]);
  const handleTextFieldChange = (event: any) => {
    event.persist();
    const key = event.target.name as keyof IData;
    setData((state) => ({ ...state, [key]: event.target.value }));
    setSavable(true);
  };
  const handleUploadAvatar = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target?.files && event.target.files[0];
    if (file) {
      setSavable(true);
      const imageUrl = URL.createObjectURL(file);
      setPhotoUrl(imageUrl);
    }
  };
  const handleClickSave = () => {
    onSave({ data, photoUrl });
  };

  return (
    <Box p={2}>
      <Grid container>
        <Grid item xs={12} md={3}>
          <Box
            display='flex'
            flexDirection='column'
            alignItems='flex-start'
            p={1}
          >
            <Typography>โปรไฟล์</Typography>
            <AvatarEditor imgUrl={photoUrl} onChange={handleUploadAvatar} />
          </Box>
        </Grid>
        <Grid item xs={12} md={9}>
          <Box mt={4}>
            {Object.entries(fields(provider)).map((field) => {
              const key = field[0];
              const value = field[1];
              return (
                <Box my={1} key={`field-${key}`}>
                  <Typography>{value.title}</Typography>
                  <TextField
                    color='secondary'
                    InputProps={{ classes: { input } }}
                    inputProps={{
                      maxLength: value.limit,
                    }}
                    className={textField}
                    variant='filled'
                    name={key}
                    size='small'
                    fullWidth
                    value={data[key as keyof IData] ?? ''}
                    disabled={value.readOnly}
                    type={value.type}
                    onChange={handleTextFieldChange}
                    placeholder={value.placeholder}
                  />
                </Box>
              );
            })}
            <Box display='flex' width='100%' justifyContent='flex-end'>
              {savable && (
                <Button
                  variant='contained'
                  color='primary'
                  className={saveButton}
                  onClick={handleClickSave}
                >
                  บันทึก
                </Button>
              )}
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ProfileForm;
